<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 2H4C2.897 2 2 2.897 2 4V6C2 6.736 2.405 7.375 3 7.722V18C3 19.103 3.897 20 5 20H19C20.103 20 21 19.103 21 18V7.722C21.595 7.375 22 6.736 22 6V4C22 2.897 21.103 2 20 2ZM4 4H20L20.002 6H20H4V4ZM5 18V8H19L19.002 18H5Z"
      fill="#1E232C"
    />
    <path d="M8 10H16V12H8V10Z" fill="#1E232C" />
    <rect x="8" y="21" width="2" height="2" rx="0.5" fill="#1E232C" />
    <rect x="11" y="21" width="2" height="2" rx="0.5" fill="#1E232C" />
    <rect x="14" y="21" width="2" height="2" rx="0.5" fill="#1E232C" />
  </svg>
</template>

<script>
export default {
  name: 'OrderSettings',
};
</script>
